<template>
  <b-container fluid class="dclients">
    <b-row>
      <b-col>
        <div class="loadingOverlay" v-if="isLoading"></div>
        <div class="text-left text-uppercase title p-3">
          All Clients
          <span class="addBtn" v-on:click="goToAddClient"> + Add Client</span>
        </div>
      </b-col>
    </b-row>
    <b-row class="m-2" v-if="!isLoading">
      <b-col lg="12" md="12" sm="12" xs="12" class="box text-left mb-3 pb-3" v-for="(client, index) in clientList" :key="index">
        <b-row>
          <b-col lg="3" md="3" sm="12" xs="12">
            <img v-if="client.attributes.image != null && client.attributes.image.data != null" :src="getImage(client.attributes.image.data.attributes.url, 'url')">
          </b-col>
          <b-col lg="9" md="9" sm="12" xs="12">
            <div class="text-right">
              <div class="actionBtn" v-on:click="deleteClient(client)">Remove</div>
            </div>
            <div class="clearfix"></div>
            <div>Client : {{client.attributes.name}}</div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="m-2" v-if="clientList.length < 1">
      <b-col lg="12" md="12" sm="12" xs="12" class="box text-left mb-3 pb-3">
        No client available yet.
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import util from '@/util'
import {mapGetters} from 'vuex'

export default {
  name: 'DClients',
  data () {
    return {
      isLoading: true,
      errors: [],
      clientList: []
    }
  },
  methods: {
    deleteClient (client) {
      this.isLoading = true
      this.$store.dispatch('deleteClient', {
        data: {
          id: client.id,
          token: this.$cookies.get('a').jwt
        },
        success: (res) => {
          this.deleteFile(client.attributes.image.data.id)
        },
        fail: () => {
          this.toast('Could not remove client. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    deleteFile (id) {
      this.$store.dispatch('deleteFile', {
        data: {
          id: id,
          token: this.$cookies.get('a').jwt
        },
        success: (res) => {
          this.toast('Remove client is done.', 'success', 'check')
          this.findAllClients()
        },
        fail: () => {
          this.toast('Image delete failed.', 'error', 'error_outline')
        }
      }).then(() => {
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    findAllClients () {
      this.isLoading = true
      this.$store.dispatch('findAllClients', {
        success: (res) => {
          this.$data.clientList = res.body.data
        },
        fail: () => {
          this.toast('Could not get clients. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    goToAddClient () {
      this.$router.push('/addclient')
    },
    getImage (imageName, section) {
      return util.getImage(imageName, section)
    },
    currencyFormat (price) {
      return util.currencyFormat(price)
    },
    toast (msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      })
    }
  },
  created () {
    this.findAllClients(0)
  },
  computed: {
    ...mapGetters([
      'clients'
    ])
  }
}
</script>

<style scoped>
.dclients {
  min-height: 100vh;
}
.title {
  border-bottom: 1px solid #ccc;
}
.box {
  border-bottom: 1px solid #ccc;
}
.actionBtn {
  float:right;
  margin-top: 5px;
  margin-left: 15px;
  color: #455A64;
}
.actionBtn:hover {
  cursor: pointer;
  color: #000;
  text-decoration: underline;
}
.addBtn {
  background-color: #FF8F00;
  padding: 5px 25px;
  text-transform: capitalize;
  margin-left: 50px;
  color: #fff;
  -webkit-transition: 300ms ease-in;
  -moz-transition: 300ms ease-in;
  -o-transition: 300ms ease-in;
  transition: 300ms ease-in;
}
.addBtn:hover {
  background-color: #FFA000;
  color: #000;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/DClients.vue